import { SymbolsAnimationFactoryAdapter } from '@/containers/symbols/factory/SymbolsAnimationFactoryAdapter'
import { SymbolContainer } from '@/containers/symbols/SymbolContainer'
import { PoolFactory } from '@base/pool/PoolFactory'
import { WinLabel } from '@/containers/winnings/WinLabel'
import { SpineAnimation } from '@base/spineAnimation/SpineAnimation'

export const SymbolsAnimationPool = new SymbolsAnimationFactoryAdapter()
export const SymbolsPool = new PoolFactory(SymbolContainer)
export const WinLabelsPool = new PoolFactory(WinLabel)
export const SymbolOutOverlayAnimationPool = new PoolFactory(SpineAnimation)
